import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Gestion des Ressources Humaines (GRH)",
  icon: "👥",
  tagline: "Maîtrisez les techniques de recrutement, gestion des talents et développement organisationnel",
  duree: "3 à 5 ans",
  diplome: "Licence/Master",
  mode: "Présentiel",
  nombreDebouches: "10",
  description: "La filière GRH forme des professionnels capables de gérer le capital humain des organisations. Notre programme couvre tous les aspects de la gestion des ressources humaines: recrutement, formation, gestion de carrières, rémunération et relations sociales.",
  objectifs: [
    "Maîtriser les techniques de recrutement et sélection",
    "Développer des compétences en gestion des talents",
    "Comprendre le droit du travail et les relations sociales",
    "Acquérir une expertise en formation et développement",
    "Maîtriser les systèmes de rémunération"
  ],
  programme: [
    {
      titre: "Licence 1 & 2",
      matieres: [
        "Introduction à la GRH",
        "Psychologie du travail",
        "Droit du travail",
        "Comportement organisationnel",
        "Communication interne",
        "Gestion administrative du personnel"
      ]
    },
    {
      titre: "Licence 3 & Master",
      matieres: [
        "Gestion des talents et carrières",
        "Formation et développement",
        "Gestion de la performance",
        "Relations sociales",
        "Systèmes d'information RH",
        "Stratégie RH"
      ]
    }
  ],
  debouches: [
    { titre: "Directeur des ressources humaines", description: "Pilotage de la stratégie RH" },
    { titre: "Responsable recrutement", description: "Gestion du processus de recrutement" },
    { titre: "Consultant RH", description: "Conseil en organisation et GRH" },
    { titre: "Gestionnaire de formation", description: "Pilotage des plans de formation" },
    { titre: "Responsable paie", description: "Gestion de la paie et administration" },
    { titre: "Chargé de relations sociales", description: "Gestion du dialogue social" }
  ],
  competences: [
    "Maîtrise des processus RH complets",
    "Compétences en recrutement et évaluation",
    "Expertise en droit social et relations de travail",
    "Capacité de gestion de conflits et médiation",
    "Compétences en communication et leadership",
    "Vision stratégique des ressources humaines"
  ]
};

export default function GRH() {
  return <FiliereTemplate filiere={filiereData} />;
}